import React, {Component} from 'react'
import Header from "../components/header"
import Footer from "../components/footer"
import '../../static/css/style.scss'
class Europe extends Component {
	state={
		deguo:[
			{
				name:'去德国读高中',
				content:'国内初中或者高中在读，先到德国学一年语言，之后插班到德国高中学习。',
				// zhuanye:['澳洲留学优势科目','法律','商科']
			},
			{
				name:'去德国读本科',
				content:'一、是通过预科学校在华考试，到德国学习预科然后进入本科学习， <br> ' +
					'二、是国内211大学读满1学期或者非211大学读满3学期，参加TestAS测试，取得aps审核证书，申请大学本科专业学习。',
				// zhuanye:['澳洲留学优势科目','MBA','医科','法律']
			},
			{
				name:'去德国读研究生',
				content:'国内大四在读或者本科毕业，申请aps审核并取得审核证书，考取合格德福成绩，申请德国大学硕士课程。',
				// zhuanye:['澳洲留学优势科目','工程','理科']
			},
			{
				name:'去德国读纯艺术',
				content:'通过艺术预科入学考试到德国读专业预科，然后参加学校入学考试进入专业。',
				// zhuanye:['澳洲留学优势科目','医学','法律','商科']
			},
		],
		deguoyoushi:[
			'德国是欧洲经济中心',
			'德国留学期间可以合法打工',
			'德国的教育严谨，专业齐全',
			'德国环境优美，世界旅游主要国家之一',
			'德国教育水平高，每所大学教育质量都有保证',
			'世界第三大留学国家，对外国学生友好热情',
			'德国学费低廉，工薪阶层都可以承受',
			'中德合作日益密切，需要大量优秀人才',
			'德国文化历史悠久，德语应用广泛',
			'德国学校开设很多英语授课内容，可以不用特地学习德语'
		],
		faguo:[
			{
				name:'法国读公立大学本科',
				content:'国内高中毕业，或高中以上学历，可提供高考成绩，中国大学录取通知书，到法国读一年语言预科，然后升读公立大学本科。',
				// zhuanye:['澳洲留学优势科目','法律','商科']
			},
			{
				name:'法国读公立大学硕士',
				content:'国内大学本科毕业，并取得A2以上法语语言成绩，到法国读一年语言预料，然后开读公立大学硕士课程。',
				// zhuanye:['澳洲留学优势科目','MBA','医科','法律']
			},
			{
				name:'法国读公立艺术院校',
				content:'国内高中或者大学本科毕业，并取得A2以上法语语言成绩，到法国读一年语言预科，然后通过艺术学考试，升读公立艺术院校。',
				// zhuanye:['澳洲留学优势科目','工程','理科']
			},
			{
				name:'法国读商学院',
				content:'国内高中毕业参加高考或者大学本科毕业，提供雅思或者托福成绩，升读商学院课程。',
				// zhuanye:['澳洲留学优势科目','医学','法律','商科']
			},
		],
		faguoyoushi:[
			'日益密切的中法关系',
			'低廉的留学费用',
			'完善的高水平教育体系',
			'发达的科技和经济水平',
			'世界通用的教育文凭',
			'悠久深厚的文化底蕴',
			'学以致用的教学理念',
			'优雅而实用的法语',
			'一视同仁的留学政策',
			'完善的社会保障体系',
		],
		yidali:[
			{
				name:'学历互认，政府扶持',
				content:'中意两国政府签署学历互认协议，很大程度方便了两国学生在彼此国家的高等学府进行学习和深造，保障学生能够学有所成。凡是意大利的公立大学，都100%被中国政府所认可。 <br><br>  同时，意大利政府对中国留学生持开放欢迎态度，通过政府保障计划学生获签率高达100%。自从2006年马可波罗计划的开放，进而2009年图兰朵计划的开放，一批又一批的学子，赶赴意大利，实现自己的人生梦想。',
			},
			{
				name:'世界高等学府人文背景源远流长',
				content:'意大利是欧洲首开现代教育大学之先行者.意大利的大学教育制度对欧洲和世界大学的教育制度产生过世界级影响。意大利的博洛尼亚大学、罗马大学、米兰理工大学等学府均是世界一流大学。拥有源远流长的人文背景的意大利大学是中国留学生选择意大利留学的主要优势之一。',
			},
			{
				name:'公立大学教育免学费',
				content:'到目前为止，意大利大学仍保留原有传统，不将教育作为可以营利的产业看待。对留学生不收取高额的学费，只收少量的注册费。',
			},
			{
				name:'生活费用指数较低医疗福利水平高',
				content:'相对于其他欧洲国家，在意大利就读的留学生的生活费可以说是欧洲较低的。学生缴纳医疗保险金后，便可以在全意大利免费享受医疗，解决了广大中国留学生的后顾之忧。',
			},
			{
				name:'注册自由门槛低',
				content:'意大利各大学均有独立的行政权，实行自由注册入学制度。大学入学条件要求低，学生只要有高中文凭和同等学历以及一定的高考成绩，均可在意大利任何一所大学注册入学。有些大学可以为低收入家庭减免部分注册费，成绩优异的留学生将有资格申请大学奖学金。',
			},
			{
				name:'意大利专业优势领域',
				content:'意大利高等教育汇集了欧洲建筑、工程、经济、管理等领域的精华，同时在音乐、绘画、设计、考古等领域世界领先。带来更多就业机会，增强就业竞争优势，多语种人才具备更广阔的发展空间。',
			},
			{
				name:'技术移民受欢迎',
				content:'近年来，意大利专业技术人才严重缺乏。新移民法明确为外国留学生在意大利学习和工作提供了法律保证。所有的这一切不仅为中国留学生在意大利提供了工作可能，而且还为中国留学生提供了移民机会。',
			},
			{
				name:'意大利语就业前景好',
				content:'意大利是中国在欧洲非常重要的贸易伙伴，越来越多的意大利公司致力于开拓中国的巨大市场。留学生们在意大利留学过程中对意大利语的熟练掌握，必将对以后的发展提供广阔空间。',
			},
		],
		zhuanye:[
			{
				name:'农业类专业',
				content:'新西兰的农业学科门类齐全，如农业技术、园艺科学、景观建筑设计、葡萄酒栽培和酿造、土地和物业管理等等。<br><br> 推荐院校林肯大学、怀卡托大学、梅西大学等。',
			},
			{
				name:'工程类专业',
				content:'新西兰的工程类专业分支很多，其中电子工程、通信工程、微电子技术等工程技术类专业一直是新西兰短缺移民类专业。<br><br> 推荐院校：坎特伯雷大学、奥克兰理工大学、奥克兰大学、怀卡托大学等。',
			},
			{
				name:'建筑专业',
				content:'在新西兰，建筑类专业是比较热门的专业之一，市场需求量比较大，就业也比较容易。一些有经验的建筑设计、施工管理人员、其年薪可以达到十万纽币以上或者更多，但入学要求相对较高。 <br><br> 推荐院校：奥克兰大学、坎特伯雷大学、维多利亚大学、惠灵顿理工学院等。',
			},
			{
				name:'教育类专业',
				content:'教育作为新西兰长期紧缺的职业，也是政府重点扶持的行业。开设教育专业的优秀学校很多，保证了极高的毕业率和就业率，而且移民也有的充分的保障。<br><br>推荐院校：奥克兰大学、梅西大学、Unitec理工学院等。',
			},
			{
				name:'会计专业',
				content:'会计专业为新西兰移民专业，学生注册会计师后即可申请移民。并且会计专业的毕业生就业范围很广，包括国企、外企、私企财会部门、金融机构等。<br><br>推荐院校：奥克兰理工大学、梅西大学、怀卡托大学等。',
			},
			{
				name:'护理专业',
				content:'护士属于新西兰的紧缺职业，且长期位于新西兰移民紧缺行业清单中；新西兰人口老龄化严重，护理专业已经成为新西兰最受重视的职业之一，一直被看作是对人类社会非常有贡献、回报又很高的职业，从事护理专业的人十分受尊敬。西方国家的护理人员需使用各种高新的医疗设备，配合医生对病人做出全面的诊断和看护。<br><br>推荐院校：梅西大学、Unitec、Ucol、Wintec等理工学院。',
			},
			{
				name:'酒店与旅游管理专业',
				content:'作为资源丰富的旅游国家，在新西兰学习酒店与管理专业的学生毕业后很好找工作，当地的酒店以及旅行社等机构也会为学生提供诸多的工作，另外在新西兰具有该专业的学生也很多，有更大的选择面，学生可以根据自身的情况申请留学目的地。<br><br>推荐院校：奥克兰理工大学、怀卡托大学、基督城理工学院、惠灵顿理工学院等。',
			},
			{
				name:'传媒专业',
				content:'新西兰传媒业的发展也是飞速的，新西兰八所国立大学大多设有传媒专业，还有一些私立大学也都设有传媒专业，这就给留学生提供了一个很好的选择空间，传媒专业的就业前景广泛，毕业生可选择在新闻媒体、传媒公司、文化公司、电台及电视台等行业工作。<br><br>推荐院校：奥克兰理工大学、维多利亚大学、坏卡托大学等。',
			}
		],
	}
	render() {
		return (
			<div className={'page'}>
				<Header/>
				<div className={'main'}>
					<img className={'banimg'} src={require('../../static/images/europe01.jpg')} alt=""/>
					<div className={'content'}>
						<div className={'title'}>
							<span>德国简介</span>
							<span className={'line'}/>
						</div>
						<div className={'contentModule'}>
							<div className={'text textJust'}>
								德意志联邦共和国（The Federal Republic of Germany），简称德国，是位于中欧的联邦议会共和制国家，北邻丹麦，西部与荷兰、比利时、卢森堡和法国接壤，南邻瑞士和奥地利，东部与捷克和波兰接壤，该国由16个联邦州组成，首都为柏林，领土面积357167平方公里，以温带气候为主，人口约8110万人，是欧洲联盟中人口最多的国家，以德意志人为主体民族。
								<br/><br/>
								德国在基础科学与应用研究方面十分发达，以理学、工程技术而闻名的科研机构和发达的职业教育支撑了德国的科学技术和经济发展。
								以汽车和精密机床为代表的高端制造业，也是德国的重要象征。</div>
							<img className={'img'} src={require('../../static/images/europe03.jpg')} alt=""/>
						</div>
						<div className={'title'}>
							<span>德国留学优势</span>
							<span className={'line'}/>
						</div>
						<div className={'youShi'}>
							{
								this.state.deguoyoushi.map((item,index)=>(
									<div className={'youShiItem'} key={index}>
										<div className={'youShiItemNum'}>{index+1}</div>
										<div className={'youShiItemNumText textJust'}>{item}</div>
									</div>
								))
							}
						</div>
						<div className={'title'}>
							<span>德国留学方案</span>
							<span className={'line'}/>
						</div>
						<div className={'mingxiao'}>
							{
								this.state.deguo.map((item,index)=>{
									return (
										<div className={'mingxiaoItem'} key={index}>
											<div className={'mingxiaoItemTitle line_wrap'}>
												<span className={'line_title'}>
													{item.name}
												</span>
											</div>
											<div className={'mingxiaoItemText textJust'} dangerouslySetInnerHTML={{__html:item.content}}/>
										</div>
									)
								})
							}
						</div>
						<div className={'title'}>
							<span>法国简介</span>
							<span className={'line'}/>
						</div>
						<div className={'contentModule resever'}>
							<img className={'img'} src={require('../../static/images/europe02.jpg')} alt=""/>
							<div className={'text textJust'}>
								法国，是一个本土位于西欧的总统共和制国家，海外领土包括南美洲和南太平洋的一些地区。该国为欧洲国土面积第三大、西欧面积最大的国家，东与比利时、卢森堡、德国、瑞士、意大利接壤，南与西班牙、安道尔、摩纳哥接壤。本土地势东南高西北低，大致呈六边形，三面临水，南临地中海，西濒大西洋，西北隔英吉利海峡与英国相望，科西嘉岛是法国最大岛屿。
								<br/><br/>
								法国是一个高度发达的资本主义国家。欧洲四大经济体之一，其国民拥有较高的生活水平和良好的社会保障制度，是联合国安理会五大常任理事国之一，也是欧盟和北约创始会员国、申根公约和八国集团成员国，和欧洲大陆主要的政治实体之一。</div>
						</div>
						<div className={'title'}>
							<span>法国留学优势</span>
							<span className={'line'}/>
						</div>
						<div className={'youShi'}>
							{
								this.state.faguoyoushi.map((item,index)=>(
									<div className={'youShiItem'} key={index}>
										<div className={'youShiItemNum'}>{index+1}</div>
										<div className={'youShiItemNumText textJust'}>{item}</div>
									</div>
								))
							}
						</div>
						<div className={'title'}>
							<span>法国留学方案</span>
							<span className={'line'}/>
						</div>
						<div className={'mingxiao'}>
							{
								this.state.faguo.map((item,index)=>{
									return (
										<div className={'mingxiaoItem'} key={index}>
											<div className={'mingxiaoItemTitle line_wrap'}>
												<span className={'line_title'}>
													{item.name}
												</span>
											</div>
											<div className={'mingxiaoItemText textJust'} dangerouslySetInnerHTML={{__html:item.content}}/>
										</div>
									)
								})
							}
						</div>
						<div className={'title'}>
							<span>意大利简介</span>
							<span className={'line'}/>
						</div>
						<div className={'contentModule'}>
							<div className={'text textJust'}>
								意大利国土面积30万平方公里，人口6010万，处于欧洲南部。国土大部分面积插入地中海，主要由靴子型的亚平宁半岛和两个位于地中海中的西西里岛和萨丁岛组成。意大利在北方阿尔卑斯山地区与法国、瑞士、奥地利以及斯洛文尼亚接壤。
									<br/><br/>
								意大利旅游业发达，旅游收入是弥补国家收支逆差的第二大来源，意大利与中国建交以来，双边关系发展顺利。2004年5月，温家宝总理对意大利进行正式访问，双方统对中国进行国事访问。2009年月7月，国家主席胡锦涛对意大利进行了国事访问，标志着中意全面战略伙伴关系迈上新台阶。2019年3月，国家主席习近平访问意大利，为中意关系注入新的动力，带来新的发展机遇。</div>
							<img className={'img'} src={require('../../static/images/europe03.jpg')} alt=""/>
						</div>
						<div className={'title'}>
							<span>意大利留学优势</span>
							<span className={'line'}/>
						</div>
						<div className={'textModule'}>
							{
								this.state.yidali.map((item,index)=>(
									<div className={'textModuleItem'} key={index}>
										<div className={'textModuleItemFlexWrap'}>
											<div className={'textModuleItemTitle'}>{item.name}</div>
											<div className={'textModuleItemText textJust'} dangerouslySetInnerHTML={{__html:item.content}}/>
										</div>
									</div>
								))
							}
						</div>
					</div>
				</div>
				<Footer/>
			</div>
		)
	}
}

export default Europe